import { create } from 'zustand';
import { shallow } from 'zustand/shallow';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

interface NotificationState {
  open: boolean;
  message: string;
  severity: NotificationSeverity;
  showNotification: (message: string, severity?: NotificationSeverity) => void;
  closeNotification: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  open: false,
  message: '',
  severity: 'success',
  showNotification: (message, severity = 'success') => {
    set({ open: true, message, severity });
  },
  closeNotification: () => {
    set({ open: false });
  },
}));

// Selector hooks for better re-render optimization
// Using shallow comparison to prevent infinite re-render loops when
// these selectors are used in useCallback dependency arrays
export const useNotification = () =>
  useNotificationStore(
    (state) => ({
      showNotification: state.showNotification,
      closeNotification: state.closeNotification,
    }),
    shallow
  );

export const useNotificationState = () =>
  useNotificationStore(
    (state) => ({
      open: state.open,
      message: state.message,
      severity: state.severity,
    }),
    shallow
  );
